import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-gray-400 pt-16 pb-8 border-t-4 border-green-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <SafeIcon icon={FiIcons.FiZap} className="text-lime-400 text-2xl" />
              <span className="font-black text-2xl tracking-tighter uppercase text-white">VoltYard</span>
            </div>
            <p className="mb-6 max-w-sm">
              Professional grade electric yard tools. Built tough for the elements, designed for zero emissions.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-sm bg-slate-800 flex items-center justify-center hover:bg-lime-400 hover:text-slate-900 transition-colors">
                <SafeIcon icon={FiIcons.FiFacebook} />
              </a>
              <a href="#" className="w-10 h-10 rounded-sm bg-slate-800 flex items-center justify-center hover:bg-lime-400 hover:text-slate-900 transition-colors">
                <SafeIcon icon={FiIcons.FiTwitter} />
              </a>
              <a href="#" className="w-10 h-10 rounded-sm bg-slate-800 flex items-center justify-center hover:bg-lime-400 hover:text-slate-900 transition-colors">
                <SafeIcon icon={FiIcons.FiInstagram} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-4">Shop</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-lime-400 transition-colors">All Tools</a></li>
              <li><a href="#" className="hover:text-lime-400 transition-colors">Starter Kits</a></li>
              <li><a href="#" className="hover:text-lime-400 transition-colors">Accessories</a></li>
              <li><a href="#" className="hover:text-lime-400 transition-colors">Replacement Parts</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-4">Policies & Support</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-start">
                <SafeIcon icon={FiIcons.FiShield} className="mr-2 mt-0.5 text-lime-400 shrink-0" />
                <span>5-Year Limited Tool Warranty</span>
              </li>
              <li className="flex items-start">
                <SafeIcon icon={FiIcons.FiTruck} className="mr-2 mt-0.5 text-lime-400 shrink-0" />
                <span>Free Shipping on Orders $100+</span>
              </li>
              <li className="pt-2">
                <a href="#" className="hover:text-lime-400 transition-colors block">Contact Us</a>
                <a href="#" className="hover:text-lime-400 transition-colors block mt-1">Manuals & Downloads</a>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs">
          <p>&copy; {new Date().getFullYear()} VoltYard Tools. All rights reserved.</p>
          <p className="mt-4 md:mt-0 font-medium text-slate-500 uppercase tracking-widest">
            Made by LingLink AI and DigLab AI
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;